module.exports = __webpack_public_path__ + "media/auto_history/wycofanie-1a7b4ab0.png";